import { FaMagic, FaRobot } from 'react-icons/fa';
import { Button } from '@/components/UI';
import { getAiBackendTriageButtonLabel, getAiCandidateCurationButtonLabel } from './helpers';

interface LegacyBackendAiActionsProps {
    actionPending: boolean;
    aiBackendTriagePending: boolean;
    aiBackendTriageRunning: boolean;
    aiCandidateCurationPending: boolean;
    aiCandidateCurationRunning: boolean;
    onAiBackendTriage: () => void;
    onAiCandidateCuration: () => void;
}

const LegacyBackendAiActions = ({
    actionPending,
    aiBackendTriagePending,
    aiBackendTriageRunning,
    aiCandidateCurationPending,
    aiCandidateCurationRunning,
    onAiBackendTriage,
    onAiCandidateCuration
}: LegacyBackendAiActionsProps) => (
    <details className="rounded border border-zinc-800 bg-zinc-950/40 p-3">
        <summary className="cursor-pointer text-sm font-medium text-zinc-300">Advanced backend AI fallback</summary>
        <div className="mt-3 flex flex-col gap-3">
            <div className="text-xs leading-5 text-zinc-500">
                These actions use Project314-hosted model calls. Prefer External AI Feature Audit + Curation and Codex Repair Workbench for
                durable reviews and source fixes.
            </div>
            <div className="flex flex-wrap gap-2">
                <Button
                    className="inline-flex items-center"
                    disabled={actionPending || aiBackendTriageRunning}
                    icon={<FaRobot />}
                    isLoading={aiBackendTriagePending || aiBackendTriageRunning}
                    size="sm"
                    variant="secondary"
                    onClick={onAiBackendTriage}
                >
                    {getAiBackendTriageButtonLabel(aiBackendTriageRunning, aiBackendTriagePending)}
                </Button>
                <Button
                    className="inline-flex items-center"
                    disabled={actionPending || aiCandidateCurationRunning}
                    icon={<FaMagic />}
                    isLoading={aiCandidateCurationPending || aiCandidateCurationRunning}
                    size="sm"
                    variant="secondary"
                    onClick={onAiCandidateCuration}
                >
                    {getAiCandidateCurationButtonLabel(aiCandidateCurationRunning, aiCandidateCurationPending)}
                </Button>
            </div>
        </div>
    </details>
);

export default LegacyBackendAiActions;
